import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { TextField, InputAdornment, Button, Box } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import routes from "routes";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function SignInBasic() {
  const { uidb64, token } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [isSignInEnabled, setIsSignInEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
  };

  const handleEmailChange = (e) => {
    const enteredValue = e.target.value;
    setEmail(enteredValue);
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enteredValue);
    if (isValidEmail) {
      setEmail(enteredValue);
    }
  };

  useEffect(() => {
    const passwordsMatch = password === confirmpassword;
    setIsSignInEnabled(passwordsMatch);
  }, [password, confirmpassword]);

  const DialogClose = () => {
    // setSubmitCompleted(false);
    window.location.href = '/portal';
  };

  console.log("uidb64", uidb64);
  console.log("token", token);
  console.log("confirmpassword", confirmpassword);

  const handleSubmitClick = () => {
    setLoading(true);
    if (isSignInEnabled) {
      const login = {
        uidb64: uidb64,
        token: token,
        password: confirmpassword,
      };
      fetch(`${process.env.REACT_APP_API_URL}/api/password-reset-complete/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(login),
      })
        .then((response) => {
          if (response.ok) {
            console.log("aaaaaaaaaaa");
            setSubmitCompleted(true);
            setLoading(false);
          }
          return response.json();
        })
        .then((data) => {
          console.log("fffffffffffffffff");
        })
        .catch((error) => {
          console.log("oooooooooooooooo");
        });
    }
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <MKBox
          position="absolute"
          top={0}
          left={0}
          zIndex={1}
          width="100%"
          minHeight="100vh"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />

        <Dialog
          open={submitCompleted}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Success!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your password has been updated successfully. Please log in to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MKButton onClick={() => { setSubmitCompleted(false); DialogClose(); }} variant="contained" color="info" size="small" autoFocus>
              OK
            </MKButton>
          </DialogActions>
        </Dialog>

        <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
          <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
            <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  mx={2}
                  mt={-3}
                  p={2}
                  mb={1}
                  textAlign="center"
                >
                  <MKTypography variant="h5" fontWeight="medium" color="white" mt={1} style={{ marginBottom: "10px" }}>
                    Forgot Password
                  </MKTypography>
                </MKBox>
                <MKBox pt={4} pb={3} px={3}>
                  <MKBox component="form" role="form">
                    <MKBox mb={2}>
                      <TextField
                        fullWidth
                        label="Password"
                        value={password}
                        onChange={handlePasswordChange}
                        type={showPassword ? 'text' : 'password'}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {showPassword ? (
                                <VisibilityOff
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Visibility
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MKBox>
                    <MKBox mb={2}>
                      <TextField
                        fullWidth
                        label="Confirm Password"
                        value={confirmpassword}
                        onChange={handleConfirmPasswordChange}
                        type={showConfirmPassword ? 'text' : 'password'}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {showConfirmPassword ? (
                                <VisibilityOff
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Visibility
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MKBox>
                    <MKBox mt={4} mb={1}>
                      <MKButton variant="gradient" color="info" onClick={handleSubmitClick} disabled={!isSignInEnabled} fullWidth>
                        sign in
                      </MKButton>
                    </MKBox>

                  </MKBox>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </MKBox>

        <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
          <SimpleFooter light />
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default SignInBasic;
